(function()
{
	function ViewControl()
	{
		this.EventDispatcher_constructor();

		this._last = null;
		this.lastID = "";
		this.current = null;
		this.currentID = "";
		this._views = {};
		this._layer = null;
		this.TransitionClass = cm.ViewTransition;
		this.transitionOverlay = null;
	}

	var p = cjs.extend(ViewControl, cjs.EventDispatcher);

	p.registerView = function(name, ViewClass, persistent)
	{
		this._views[name] = {
			viewClass: ViewClass,
			persistent: !!persistent,
			instance: null
		};
	};

	p.setViewLayer = function(layer)
	{
		this._layer = layer;
	};

	p.setTransitionLayer = function(layer, transitionClass)
	{
		this.transitionOverlay = new transitionClass();
		this.transitionOverlay.build();
		layer.addChild(this.transitionOverlay);
	};

	p.getViewInstance = function(name)
	{
		return this._views[name] ? this._views[name].instance : null;
	};

	p.update = function(tick)
	{
		if (this.current) this.current.update(tick);
	};

	p.resize = function()
	{
		if (this.current) this.current.resize(cm.app.display.width, cm.app.display.height);
	};

	p.gotoView = function(name, options)
	{
		var view = this._views[name];
		if (!view)
		{
			console.log("No View with name: " + name);
			return;
		}

		this.isTransitioning = true;

		var t;
		if(this.current)
		{

			this._last = this.current;
			this.current = null;

			this._lastID = this.currentID;
			this._last.setActive(false);
			t = this._last.animateOut();
			cjs.Tween.get(this)
				.wait(t)
				.call(this._last.destroy, null, this._last)
				.call(this.gotoView, [name], this);
			return;
		}

		this.currentID = name;
		this.current = view.instance || new view.viewClass(options);
		this.current.reset();
		cjs.Tween.get(this).wait(1000).call(this.transitOut, null, this);
		this._layer.removeAllChildren();
		this._layer.addChild(this.current);

		t = this.current.animateIn();
		cjs.Tween.get(this)
			.wait(t)
			.call(this.current.start, null, this.current)
			.set({
				isTransitioning: false,
				_last: null
			}, this);
	};

	p.gotoLoaderThen = function(manifest, callback)
	{
		// var t = this.transitIn();
		var timer = cjs.Tween.get(this).wait(t.duration);
		if(this.current)
		{
			this._last = this.current;
			this.current = null;
			this._lastID = this.currentID;
			this._last.setActive(false);
			this._last.animateOut();
			timer.call(this._last.destroy, null, this._last).call(this._layer.removeAllChildren, null, this._layer);
		}

		if(typeof callback === "string")
			callback = this.gotoView.bind(this, callback);

		timer.call(cm.Assets.load, [manifest, callback], cm.Assets);
	};

	p.transitOut = function()
	{
		return this.transitionOverlay.transitOut();
	};

	p.transitIn = function()
	{
		return this.transitionOverlay.transitIn();
	};

	var ViewControlClass = createjs.promote(ViewControl, "EventDispatcher");
	cm.ViewControl = new ViewControlClass();
})();